'use client'

import MainLayout from '@/components/page-specific/authentication/mainLayout'
import React from 'react'

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <MainLayout>{children}</MainLayout>
}

export default Layout
